export default __webpack_public_path__ + "static/media/gallery-wip-emitter_06.e6180a76.jpg";